import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export default function AuthCallback() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { setUser, setToken } = useAuthStore()
  const [error, setError] = useState('')

  useEffect(() => {
    const code = searchParams.get('code')
    if (!code) {
      setError('缺少授权码')
      return
    }

    // 调用后端 API 换取 token
    const exchangeCode = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/callback`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code }),
        })

        const data = await response.json()

        if (data.success) {
          setToken(data.data.token)
          setUser(data.data.user)
          navigate('/user')
        } else {
          setError(data.error?.message || '登录失败')
        }
      } catch (err) {
        setError('网络错误，请重试')
      }
    }

    exchangeCode()
  }, [searchParams, setUser, setToken, navigate])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="cyber-card p-8 text-center">
          <div className="text-cyber-pink text-6xl mb-4">✕</div>
          <h1 className="text-2xl font-bold mb-4">登录失败</h1>
          <p className="text-gray-400 mb-6">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="cyber-button"
          >
            返回首页
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-cyber-blue/30 border-t-cyber-blue rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-400">正在登录...</p>
      </div>
    </div>
  )
}
